import { FC } from 'react';
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { CalibrationItem, Question } from 'types';
import { formatQuestion } from 'utils/custom-question/formatter';
import RichTextViewer from 'views/Widgets/Inputs/RichTextViewer';
import Avatar from 'views/Widgets/People/Avatar';

type Props = {
  question: Question;
  calibrationItem: CalibrationItem;
};

const CalibrationEntry: FC<Props> = ({ question, calibrationItem }) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <Row className="flex-nowrap">
        <Col className="col-auto">
          <Avatar
            person={calibrationItem.author}
            size="xs"
            isExternalUrl={true}
          />
        </Col>
        <Col className="col ms-n3">
          <div className="comment-body d-block px-3 py-2 small">
            <Row>
              <Col>
                <div>
                  <span className="small me-2 py-1 fs-5 text-muted">
                    <FormattedDate value={calibrationItem.created_at} />
                  </span>
                </div>
                <div>
                  <span className="fw-bold small">
                    <span className="text-dark">
                      {calibrationItem.author.full_name}
                    </span>
                    {calibrationItem.author.title && (
                      <span className="fw-normal">
                        {', '}
                        {calibrationItem.author.title}
                      </span>
                    )}
                  </span>
                </div>
                <div className="py-1">
                  <span>
                    {formatQuestion(
                      question,
                      calibrationItem.value,
                      formatMessage
                    )}
                  </span>
                </div>
                {calibrationItem.comment && (
                  <div className="mb-0 py-1 fst-italic">
                    <RichTextViewer
                      expanded={true}
                      model={calibrationItem.comment}
                    />
                  </div>
                )}
                {!calibrationItem.comment && (
                  <div className="mb-0 py-1 fst-italic">
                    <FormattedMessage
                      id="app.views.widgets.dashboards.team_dashboard.no_comments_provided"
                      defaultMessage="No comments provided"
                    />
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default CalibrationEntry;
